import { ToolbarCommentIcon } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS } from '@editor/config/constants'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'

import useMainCanvas from './hooks/useMainCanvas'

const RebarDetection: EditorTool = {
  key: EDITOR_TOOLS.COMMENT,
  authCheck: () => true,
  toolbar: {
    icon: <ToolbarCommentIcon width="50%" height="50%" />,
    label: EDITOR_TOOLS_LABELS.COMMENT,
    category: ToolbarCategory.Manipulate,
  },
  hooks: {
    useMainCanvas,
  },
}

export default RebarDetection
